import { PermissionRole } from './permissionRole';

export interface UserRole {
  id?: number;
  name?: string;
  reportTax?: boolean;
  defaultBookingTypeId?: number;
  /**
   * Customers of this role cannot sign in on this tenant (`customertype.SignInDisabled`): turned on
   * for the organisation types (forening, virksomhed, intern) where the organisation's people sign
   * in with their own users. They get no username and no set-up mail.
   */
  signInDisabled?: boolean;
  permissionRoles?: PermissionRole[];
}

/**
 * Whether customers of a role cannot sign in on this tenant
 * @remarks Per tenant, so it is read from the role list (`GET /roles`), never from a fixed list of
 * role ids. A role missing from the list, or a list from before the flag, counts as one that can.
 * @param roles The roles as `GET /roles` returns them
 * @param roleId The role to look up, e.g. `User.primaryRole`
 * @returns True when the role has `signInDisabled`
 */
export function isSignInDisabled(
  roles: readonly Pick<UserRole, 'id' | 'signInDisabled'>[] | null | undefined,
  roleId: number | null | undefined,
): boolean {
  return roleId != null && !!roles?.some((role) => role.id === roleId && role.signInDisabled);
}
